export function joinWithDelimiter(array, delimiter) {
  return array.join(delimiter);
}

/**
 * Normalizes a status string by removing spaces and converting to uppercase.
 * Example: "Ready To Be Prepared" => "READYTOBEPREPARED"
 * @param {string} status
 * @returns {string}
 */
export function normalizeStatusString(status) {
  if (!status) return '';
  return status.replace(/\s+/g, '').toUpperCase();
}
